import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../../admin/Constant";

export const ContactApi = createApi({
  reducerPath: "ContactApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    updateContactApi: builder.mutation({
      query: ({ id, data }) => ({
        url: `/contacts/update-status/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    allContact: builder.query({
      query: () => ({
        url: "/contacts/all",
        method: "GET",
      }),
    }),
    createEnquiryApi: builder.mutation({
      query: (enquiryData) => ({
        url: "contacts/enquiry",
        method: "POST",
        body: enquiryData,
      }),
    }),
  }),
});
export const { useAllContactQuery, useUpdateContactApiMutation , useCreateEnquiryApiMutation} = ContactApi;
